import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const EASE = [0.16, 1, 0.3, 1];

export default function Legal() {
  const { page } = useParams();
  const { t } = useTranslation();
  const valid = ["mentions", "cgv", "privacy"];
  const key = valid.includes(page) ? page : "mentions";
  const doc = t(`legal.${key}`, { returnObjects: true });

  return (
    <main data-testid={`legal-page-${key}`}>
      <Header />
      <div className="pt-36 pb-24 max-w-3xl mx-auto px-6 lg:px-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: EASE }}>
          <h1 className="font-display font-semibold tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl">{doc.title}</h1>
          <div className="mt-12 space-y-10">
            {doc.sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-display font-semibold text-white text-xl tracking-tight">{s.h}</h2>
                <p className="mt-3 text-sm lg:text-base text-white/55 leading-relaxed">{s.p}</p>
              </section>
            ))}
          </div>
        </motion.div>
      </div>
      <Footer />
    </main>
  );
}
